export enum XpressDisciplinaryStatus {
    None = 0,
    New = 1,
    Pending = 2,
    Hearing = 3,
    Investigating = 4,
    Meeting = 5,
    Cleared = 6,
    Banned = 7,
    Closed = 8,
    Suspension = 9
}
